import { createFileRoute } from '@tanstack/react-router'

import { AuthSignUpPage } from '@/features/auth/pages'
import { AuthModes } from '@/features/auth/policy'
import { useTenantOptional } from '@/shared/contexts/TenantContext'

export const Route = createFileRoute('/_event/auth/sign-up')({
  staticData: {
    auth: {
      mode: AuthModes.BOOTSTRAP,
      requiresDigitalProductId: false
    }
  },
  component: TenantAuthSignUpRoute
})

function TenantAuthSignUpRoute() {
  const tenant = useTenantOptional()

  return (
    <AuthSignUpPage digitalProductId={tenant?.digitalProductId ?? undefined} />
  )
}
